import { render, staticRenderFns } from "./SuggestedTags.vue?vue&type=template&id=164d2927&scoped=true&"
import script from "./SuggestedTags.vue?vue&type=script&lang=js&"
export * from "./SuggestedTags.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTags.vue?vue&type=style&index=0&id=164d2927&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d2927",
  null
  
)

export default component.exports